import React, { useMemo } from 'react';
import { useEmpresa } from '../contexts/EmpresaContext';

// Seletor de empresa ativa (topbar). Só renderiza se houver 2+ empresas.
// Visual alinhado com o tema claro do layout de outubro/2026.
export default function EmpresaSelector() {
  const { empresas, empresaAtiva, setEmpresaAtiva } = useEmpresa();

  const opcoes = useMemo(() => empresas || [], [empresas]);

  if (!empresaAtiva || opcoes.length < 2) return null;

  const corBadge = empresaAtiva.tipo === 'cliente'
    ? { bg: 'rgba(96,165,250,0.15)', fg: '#60a5fa', borda: 'rgba(96,165,250,0.4)' }
    : { bg: 'rgba(124,58,237,0.18)', fg: '#a78bfa', borda: 'rgba(124,58,237,0.45)' };

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 6,
        background: '#f7f5fb',
        border: '1px solid #e5e0ef',
        borderRadius: 8,
        padding: '4px 10px',
        minWidth: 0,
      }}
      title="Empresa ativa"
    >
      <span style={{ fontSize: 14, flexShrink: 0 }} aria-hidden="true">🏢</span>
      <select
        value={empresaAtiva.slug}
        onChange={(e) => setEmpresaAtiva(e.target.value)}
        style={{
          background: 'transparent',
          color: '#1c1530',
          border: 'none',
          outline: 'none',
          fontSize: 13,
          fontWeight: 600,
          cursor: 'pointer',
          padding: '2px 0',
          flex: '1 1 auto',
          minWidth: 0,
          maxWidth: '100%',
        }}
        aria-label="Selecionar empresa ativa"
      >
        {opcoes.map(emp => (
          <option key={emp.slug} value={emp.slug} style={{ background: '#f7f5fb', color: '#1c1530' }}>
            {emp.nomeFantasia || emp.slug}
          </option>
        ))}
      </select>
      <span
        style={{
          fontSize: 10,
          fontWeight: 700,
          letterSpacing: 0.3,
          textTransform: 'uppercase',
          padding: '2px 6px',
          borderRadius: 4,
          background: corBadge.bg,
          color: corBadge.fg,
          border: `1px solid ${corBadge.borda}`,
          whiteSpace: 'nowrap',
          flexShrink: 0,
        }}
      >
        {empresaAtiva.tipo === 'cliente' ? 'cliente' : 'própria'}
      </span>
    </div>
  );
}
